import { AxiosPromise } from 'axios';
import { IAdminLoginPageFormValues } from './types';
import { instance } from '../../../services';

const attemptAdminLogin = (data: IAdminLoginPageFormValues): AxiosPromise =>
  instance.post('api/accounts/admin', data);

export default attemptAdminLogin;
